import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { SharedService } from '../../_service/shared.service';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { LeadsService } from '../../_service/leads.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProductService } from 'src/app/_service/product.service';
import { ProductModelComponent } from '../product-model/product-model.component';
declare var $: any;
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import htmlToPdfmake from 'html-to-pdfmake';
import { ProductTrackModelComponent } from '../product-track-model/product-track-model.component';
import { Router } from '@angular/router';
import * as XLSX from 'xlsx';
import {formatDate} from '@angular/common';
@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.css']
})
export class ProductsComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('dateRangeStart', { static: false }) dateRangeStart: ElementRef;
  @ViewChild('dateRangeEnd', { static: false }) dateRangeEnd: ElementRef;
  @ViewChild('pdfTable') pdfTable: ElementRef;
  @ViewChild('csvUpload', {static: false}) csvUpload: ElementRef;
  @ViewChild('csvUploadWithLeads', {static: false}) csvUploadWithLeads: ElementRef;

  perpage: number = 25; productList: any = []; length: number = 0; pageEvent: PageEvent; loading: boolean = true; role: string; pageSizeOptions = [10, 25, 50, 100]; pageIndex: number = 0; loaded: boolean = false; search: string; currentUserId: any; booleanValue: any = false; start_date: string = ''; end_date: string = ''; cm_access = '';
  circle = ''; circles = []; circles_copy = []; sc3Url: string = '';bd:string;bds=[];bds_copy=[];treatment='';treatments=[];treatments_copy=[];status='';created_by:string;history_loading:boolean=true;history_loaded:boolean=false;updatedLodData=[];
  ProductID:any='';txt:string='Copy';productDetail:any={};submitted:boolean=false;showTrackingLoading=[];userId:string;

  constructor(private sharedapi: SharedService, public leadapi: LeadsService, private dialog: MatDialog, private productapi: ProductService, private router: Router,) { }

  ngOnInit(): void {
    this.sharedapi.getCMAccess().subscribe((item: string) => { this.cm_access = item });
    this.sharedapi.getLeadSourceOfUser()
    this.role = localStorage.getItem('role');
    this.userId = localStorage.getItem('loginuserId');
    this.sc3Url = localStorage.getItem('s3url');
    this.cm_access = localStorage.getItem('CMAccess');
    this.getcircle();this.getbds();this.getTreatment();
  }

  ngAfterViewInit() {
    this.loadProducts(0, this.perpage);
  }
  setSearchValue(type) {
    if (type == 'circle') {
      $("#circleSearch").val('');
      $("#circleSearch").focus();
      this.circles = this.circles_copy;
    } else if(type=='bds'){
      $("#bd_search").val('');
      $("#bd_search").focus();
      this.bds= this.bds_copy;
    } else if(type=='treatment'){
      $("#treatmentSearch").val('');
      $("#treatmentSearch").focus();
      this.treatments= this.treatments_copy;
    }
  }

  searchOnSelect(searchtText: string, type) {
    if (type == 'circle') {
      this.circles = this.sharedapi.searchData(searchtText, this.circles_copy, "name");
    } else if(type == 'bds'){
      this.bds = this.sharedapi.searchData(searchtText, this.bds_copy, "name");
    } else  if (type == 'treatment') {
      this.treatments = this.sharedapi.searchData(searchtText, this.treatments_copy, "name");
    } 
  }

  async loadProducts(pageIndex, perpage) {
    this.productList = [];
    this.paginator.pageIndex = pageIndex;
    let qString = 'search=' + this.search + '&circle=' + this.circle +'&treatment=' +this.treatment +'&status=' +this.status + '&bd='+ this.bd  + '&created_by='+ this.created_by + '&date_range=' + this.start_date + '-' + this.end_date;
    this.loading = true; this.loaded = false;
    await this.productapi.getProducts(this.paginator.pageIndex, perpage, qString)
      .subscribe((data: any) => {
        this.length = parseInt(data.totaldata);
        this.loading = false;
        this.loaded = true;
        if (data.status) {
          this.productList = data.data;
        } else {
          this.productList = [];
          this.sharedapi.presentToast(data.msg);
        }
      }, error => {
        this.loading = false;
        this.loaded = true;
        this.sharedapi.checkError(error);
      });
  }

  pageChange(event) {
    this.pageIndex = event.pageIndex;
    this.loadProducts(event.pageIndex, event.pageSize);
  }

  public getServerData(event: PageEvent): any {
    this.perpage = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.loadProducts(event.pageIndex, event.pageSize);
  }

  dateRangeChange(date1, date2) {
    if (date2.value) {
      this.start_date = date1.value;
      this.end_date = date2.value;
    }
  }

  resetFilters() {
    this.clearDate();
    this.search = ''; this.circle = '';this.treatment = '';this.bd = '';this.status = '';this.created_by = "";
    this.loadProducts(0, 25);
  }

  clearDate() {
    this.dateRangeStart.nativeElement.value = "";
    this.dateRangeEnd.nativeElement.value = "";
    this.start_date = '';
    this.end_date = '';
  }

  async getcircle() {
    this.leadapi.getcircles().subscribe((data: any) => {
      if (data.status) {
        this.circles = data.data;
        this.circles_copy = this.circles;
      } else {
        this.circles = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  async getbds(status=1)
    {
        this.leadapi.getbds(status).subscribe((data:any) => {
            if(data.status)
            {
                this.bds = data.data;
                this.bds_copy = this.bds;
            }else{
                this.bds = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getTreatment()
    {
        this.leadapi.getSexualWellnessTreatments().subscribe((data:any) => {
            if(data.status)
            {
                this.treatments = data.data;
                this.treatments_copy = this.treatments;
            }else{
                this.treatments = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    updateProductDetails(lead_id)
    {
     this.openProductDialog(lead_id);
    }

    openProductDialog (lead_id) 
    {
        const dialogRef = this.dialog.open(ProductModelComponent, {
            width: '100%',height: '95%',
            data:{lead_id:lead_id}
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log(result);
        });
    }

    openProductHistoryPopup(productBookingId)
    {
        this.history_loading = true;this.history_loaded = false;
        this.productapi.getFullProductHistory(productBookingId).subscribe((data:any) => {
            this.history_loading = false;
            this.history_loaded = true;
            if(data.status)
            {
                this.updatedLodData = data.data;
            }else{
                this.updatedLodData = [];
            }
        }, error => {
                this.sharedapi.checkError(error);
        });
        $('#myHistoryModal').modal();
    }

    closeHistoryPopup()
    {
        $('#myHistoryModal').modal('hide');
    }

    async viewProduct(product_id)
    {
        this.ProductID= product_id;
        this.txt='Copy';
        $('#myModal').modal();
        await this.productapi.viewProductDetails(product_id).subscribe((data:any) => {
            if(data.status)
            {
                this.productDetail = data.data;
            }else{
                this.productDetail = {};
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    hideModal(val)
    {
        if(val=='1'){
            $('#myModal').modal('hide');
        }
    }

    public downloadAsPDF() {
      const pdfTable = this.pdfTable.nativeElement;
      var html = htmlToPdfmake(pdfTable.innerHTML);
      const documentDefinition = { content: html };
      pdfMake.createPdf(documentDefinition).download('PRO_'+this.ProductID+'.pdf');
  }

  hideModalProduct()
  {
      $('#myModalProduct').modal('hide');
  }

  showModalProduct()
  {
      $('#myModalProduct').modal();
  }

  async selectFile(event)
  {
      this.submitted = true;
      let file = event.target.files.item(0);
      const formData = new FormData();
      formData.append('file', file);
      this.productapi.uploadProductCsv(formData)
      .subscribe((data:any) => {
          this.submitted = false;
          this.csvUpload.nativeElement.value = "";
          if(data.status)
          {
              this.hideModalProduct();
              this.sharedapi.presentToast(data.msg);
              this.loadProducts(0, this.perpage);
          }
          else
          {
              this.sharedapi.presentToast(data.msg);
          }
        }, error =>
          {
              this.sharedapi.checkError(error);
          });
  }

  createProductOrder(lead_id) 
    {
        const dialogRef = this.dialog.open(ProductTrackModelComponent, {
            width: '100%',height: '95%',
            data:{lead_id:lead_id}
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log(result);
        });
    }

    productTracking(productBookingId,index)
    {
      this.showTrackingLoading[index] = true;
        this.productapi.productTracking(productBookingId).subscribe((data:any) => {
          this.showTrackingLoading[index] = false;
            if(data.status)
            {
              var trackingUrl = data.data;
              window.open(trackingUrl)
            }else{
              this.sharedapi.presentToast(data.msg);
            }
        }, error => {
                this.sharedapi.checkError(error);
        });
    }

    updateProductOrder(res_order_id) 
    {
        const dialogRef = this.dialog.open(ProductTrackModelComponent, {
            width: '100%',height: '95%',
            data:{res_order_id:res_order_id}
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log(result);
        });
    }

//------------------Export Product List---------------------//
exportProductList() {
  if (this.productList.length > 0) {
    let data = [];
    let titles = ['APPOINTMENT ID', 'GLAMYO PATIENT ID', 'GLAMYO APPOINTMENT ID','STATUS','PATIENT NAME','PATIENT AGE','GENDER','ADDRESS','PATIENT MOBILE','LEAD LOCATION','CIRCLE','CLINIC','LEAD OWNER','BOOKING DATE','INVOICE AMOUNT','BOOKING OWNER','PRODUCT & Quantity'];
   
    data.push(titles);
    for (let key in this.productList) {

      var status = '';
      if(this.productList[key].status == 1){
        status = 'New';
      } else if(this.productList[key].status == 2){
        status = 'Verified';
      } else if(this.productList[key].status == 3){
        status = 'Pending';
      }else if(this.productList[key].status == 4){
        status = 'RTO';
      }else if(this.productList[key].status == 5){
        status = 'Delivered';
      }else if(this.productList[key].status == 6){
        status = 'Postponed';
      }else if(this.productList[key].status == 7){
        status = 'Dispatched';
      }else if(this.productList[key].status == 8){
        status = 'Cancelled';
      }

      var booking_date =''; 
      if(this.productList[key].booking_date){
        booking_date = formatDate(this.productList[key].booking_date*1000, 'dd MMM, yyyy', 'en-US');
      }
     
      let product_quantity_arr = [];
      if(this.productList[key].product_details){
        product_quantity_arr = this.productList[key].product_details;
      }

      let product_quantity = '';
      if(product_quantity_arr)
      {
        for(let product in product_quantity_arr)
        {
          if(product_quantity_arr[product].product_id && product_quantity_arr[product].quantity){
            product_quantity += product_quantity_arr[product].product_id +' = '+ product_quantity_arr[product].quantity +'\n';
          }
        }
      }

      let extData = [this.productList[key].patient_id, this.productList[key].glamyo_patient_id,'GHPRO'+this.productList[key].id,
      status,this.productList[key].patient_name,this.productList[key].patient_age,this.productList[key].gender,this.productList[key].address,this.productList[key].patient_mobile,this.productList[key].city_name,this.productList[key].circle_name,this.productList[key].hospital_name,this.productList[key].bd_name,booking_date,this.productList[key].invoice_amount,this.productList[key].product_booking_owner,product_quantity];

      data.push(extData)
    }
    let ws = XLSX.utils.aoa_to_sheet(data);
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    let utc = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
    XLSX.writeFile(wb, 'productlist_' + utc + '.xlsx');
  } else {
    this.sharedapi.presentToast('No Product Data found!');
  }
}

showModalProduct2()
{
      $('#myModalProduct2').modal();
}

hideModalProduct2()
{
    $('#myModalProduct2').modal('hide');
}

async selectFileWithLeads(event)
  {
      this.submitted = true;
      let file = event.target.files.item(0);
      const formData = new FormData();
      formData.append('file', file);
      this.productapi.uploadProductCsvWithLeads(formData)
      .subscribe((data:any) => {
          this.submitted = false;
          this.csvUploadWithLeads.nativeElement.value = "";
          if(data.status)
          {
              this.hideModalProduct2();
              this.sharedapi.presentToast(data.msg);
              this.loadProducts(0, this.perpage);
          }
          else
          {
              this.sharedapi.presentToast(data.msg);
          }
        }, error =>
          {
              this.sharedapi.checkError(error);
          });
  }

}


